export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m14.5039 11.9961-5-3v6l5-3z" } }];
export const iconName = 'bullet';
export const bullet = { iconName, paths };
export default paths;
